import React from 'react';

import useTaskField from '@dyl/pages/Tasks/edit/useTaskField';
import { TextField } from '@mui/material';
import useChangeEvent from '@dyl/hooks/useChangeEvent';
import Node from '@dyl/task-types/Shared/Node';

export default function Stimulus({ index, pageIndexOffset = 0, minRows = 3 }) {
    const [stimulus, setStimulus, stimulusError] = useTaskField('items', index, 'stimulus');
    const onStimulusChange = useChangeEvent(setStimulus);
    return (
        <>
            <TextField
                multiline
                minRows={minRows}
                label={index === 4 ? 'Example stimulus' : `Item ${index - 1}`}
                value={stimulus}
                onChange={onStimulusChange}
                fullWidth
                variant='filled'
                error={!!stimulusError}
                helperText={stimulusError || ' '}
                InputProps={{
                    endAdornment: <Node lineId={index} side='start' />,
                }}
            />
        </>
    );
}